import type {
  FilterCollection,
  CategoryId,
  SubcategoryId,
} from "$lib/types/index";
import { poiStore } from "$lib/stores/pois.svelte";

class FiltersStore {
  categories = $state([
    {
      id: "coupon",
      label: "Kupon",
      icon: "coupon",
      description: "Spórolj akár 50%-ot boltokban és online",
      detail:
        "Fedezd fel a legjobb kuponokat és kedvezményeket. Akár 50% megtakarítást érhetsz el online vásárlásoknál és helyi boltokban egyaránt. Regisztrálj és szerezd meg a legfrissebb ajánlatokat!",
      active: false,
    },
    // {
    //   id: "irrigation",
    //   label: "Fák öntözése",
    //   icon: "plant",
    //   description: "Ebben a melegben a fák is szomjasak!",
    //   detail:
    //     "Segíts megőrizni a városi zöldfelületeket! A nyári hőségben különösen fontos a fák és növények öntözése. Csatlakozz a közösségi öntözési programokhoz és járulj hozzá a környezeted szépítéséhez.",
    //   active: false,
    // },
    {
      id: "market",
      label: "Vásárlás",
      icon: "store",
      description: "Vásárolj tudatosan a boltokban és online is!",
      detail:
        "Tudatos vásárlással nem csak pénzt spórolhatsz, de a környezetet is véded. Tanuld meg, hogyan válassz fenntartható termékeket, hol találod a legjobb árakat és hogyan kerülheted el a felesleges vásárlásokat.",
      active: false,
    },
    {
      id: "hungry",
      label: "Éhes vagyok",
      icon: "restaurant",
      description: "Piacok, éttermek és sok más, ahol jól laksz!",
      detail:
        "Maradék ételeket új fogásokká alakíthatod! Fedezd fel a kreatív főzés világát, tanulj meg újrahasznosítani az ételmaradékokat és csökkentsd az élelmiszerpazarlást. Receptek és tippek várnak rád!",
      active: false,
    },
    {
      id: "repair",
      label: "Javítás",
      icon: "repair",
      description: "Ne vegyél újat, inkább éleszd újra!",
      detail:
        "A javítás kultúrája nemcsak környezetbarát, de költséghatékony is. Találj javítószervizeket a közeledben, tanulj meg alapvető javítási technikákat, vagy csatlakozz repair café eseményekhez!",
      active: false,
    },
    {
      id: "rent",
      label: "Kölcsönzés",
      icon: "bike_rental",
      description: "Minek saját, ha kölcsönözhetsz is!",
      detail:
        "Minek vásárolni, ha kölcsönözhetsz? Kerékpároktól kerti eszközökig, minden megtalálható a kölcsönzési platformokon. Spórolj helyet és pénzt, miközben fenntarthatóan élsz!",
      active: false,
    },
    {
      id: "waste",
      label: "Hulladék",
      icon: "waste",
      description: "Neked hulladék, másnak alapanyag!",
      detail:
        "A körforgásos gazdaság alapelve: amit te nem használsz, az másnak értékes lehet. Tanuld meg, hogyan add tovább, cseréld el vagy hasznosítsd újra a számودra feleslegessé vált tárgyakat!",
      active: false,
    },
  ]);

  couponFilter = $state(false);

  activeCategory = $derived(this.categories.find((c) => c.active));

  toggleCategory(id: string) {
    this.couponFilter = false;
    const wasActive = this.categories.find((c) => c.id === id)?.active ?? false;

    Object.values(this.filters).forEach((category) => {
      category.allEnabled = wasActive;
      Object.values(category.subcategories).forEach((subcategory) => {
        subcategory.enabled = wasActive;
      });
    });

    this.categories.forEach(
      (c) => (c.active = c.id === id ? !wasActive : false)
    );

    if (wasActive) {
      poiStore.applyFilters();
      return;
    }

    switch (id) {
      case "coupon":
        this.couponFilter = true;
        break;
      case "irrigation":
        this.filters.STATION.allEnabled = true;
        this.filters.STATION.subcategories.PLANT.enabled = true;
        break;
      case "market":
        this.filters.STORE.allEnabled = true;
        Object.values(this.filters.STORE.subcategories).forEach(
          (sub) => (sub.enabled = true)
        );
        break;
      case "hungry":
        this.filters.RESTAURANT.allEnabled = true;
        Object.values(this.filters.RESTAURANT.subcategories).forEach(
          (sub) => (sub.enabled = true)
        );
        break;
      case "repair":
        this.filters.REPAIR.allEnabled = true;
        Object.values(this.filters.REPAIR.subcategories).forEach(
          (sub) => (sub.enabled = true)
        );
        break;
      case "rent":
        this.filters.RENTAL.allEnabled = true;
        Object.values(this.filters.RENTAL.subcategories).forEach(
          (sub) => (sub.enabled = true)
        );
        break;
      case "waste":
        this.filters.WASTE.allEnabled = true;
        Object.values(this.filters.WASTE.subcategories).forEach(
          (sub) => (sub.enabled = true)
        );
        break;
    }

    poiStore.applyFilters();
  }

  filters = $state<FilterCollection>({
    STORE: {
      id: "STORE",
      allEnabled: true,
      open: false,
      name: "Üzletek",
      subcategories: {
        ZERO_WASTE: {
          id: "ZERO_WASTE",
          value: "Zöld vegyesbolt",
          enabled: true,
        },
        MARKET: { id: "MARKET", value: "Piac", enabled: true },
        LOCAL_PRODUCER: {
          id: "LOCAL_PRODUCER",
          value: "Gazdaság",
          enabled: true,
        },
        USED_GADGETS: {
          id: "USED_GADGETS",
          value: "Használt tárgyak",
          enabled: true,
        },
        USED_CLOTHES: {
          id: "USED_CLOTHES",
          value: "Használt ruha",
          enabled: true,
        },
        DONATION_SHOP: {
          id: "DONATION_SHOP",
          value: "Adománybolt",
          enabled: true,
        },
        BOOK_STORE: { id: "BOOK_STORE", value: "Antikvárium", enabled: true },
        FARM_STORE: {
          id: "FARM_STORE",
          value: "Termelői közösség",
          enabled: true,
        },
        MANUFACTORY: { id: "MANUFACTORY", value: "Kézműves", enabled: true },
        BEAUTY: { id: "BEAUTY", value: "Szépségápolás", enabled: true },
        WEBSHOP: { id: "WEBSHOP", value: "Webshop", enabled: true },
        OTHER_SHOP: { id: "OTHER_SHOP", value: "Egyéb üzlet", enabled: true },
      },
    },
    RESTAURANT: {
      id: "RESTAURANT",
      allEnabled: true,
      open: false,
      name: "Étkezés",
      subcategories: {
        RESTAURANT: { id: "RESTAURANT", value: "Étterem", enabled: true },
        CAKE_SHOP: { id: "CAKE_SHOP", value: "Cukrászda", enabled: true },
        BAKERY: { id: "BAKERY", value: "Pékség", enabled: true },
        CAFE: { id: "CAFE", value: "Kávézó", enabled: true },
      },
    },
    RENTAL: {
      id: "RENTAL",
      allEnabled: true,
      open: false,
      name: "Kölcsönzés",
      subcategories: {
        SPORTS_EQUIPMENT: {
          id: "SPORTS_EQUIPMENT",
          value: "Sportszer kölcsönzés",
          enabled: true,
        },
        BIKE_RENTAL: {
          id: "BIKE_RENTAL",
          value: "Kerékpár kölcsönzés",
          enabled: true,
        },
        CAR_RENTAL: {
          id: "CAR_RENTAL",
          value: "Autó kölcsönzés",
          enabled: true,
        },
        MACHINE_RENTAL: {
          id: "MACHINE_RENTAL",
          value: "Gép és eszköz bérlés",
          enabled: true,
        },
        LIBRARY: { id: "LIBRARY", value: "Könyvtár", enabled: true },
        OTHER_RENTAL: {
          id: "OTHER_RENTAL",
          value: "Egyéb kölcsönzés",
          enabled: true,
        },
      },
    },
    REPAIR: {
      id: "REPAIR",
      allEnabled: true,
      open: false,
      name: "Javítás",
      subcategories: {
        BIKE_REPAIR: {
          id: "BIKE_REPAIR",
          value: "Bringa szerviz",
          enabled: true,
        },
        CLOTHES_REPAIR: {
          id: "CLOTHES_REPAIR",
          value: "Varroda",
          enabled: true,
        },
        SHOE_MAKER: { id: "SHOE_MAKER", value: "Cipész", enabled: true },
        WATCH_MAKER: { id: "WATCH_MAKER", value: "Órás", enabled: true },
        ELECTRIC_DEVICE: {
          id: "ELECTRIC_DEVICE",
          value: "Elektronikai szerviz",
          enabled: true,
        },
        COOP: { id: "COOP", value: "Közösségi műhely", enabled: true },
        CARPENTER: { id: "CARPENTER", value: "Asztalos", enabled: true },
        OTHER_REPAIR: {
          id: "OTHER_REPAIR",
          value: "Egyéb szervíz",
          enabled: true,
        },
      },
    },
    WASTE: {
      id: "WASTE",
      allEnabled: true,
      open: false,
      name: "Hulladék",
      subcategories: {
        SELECTIVE: {
          id: "SELECTIVE",
          value: "Szelektív sziget",
          enabled: true,
        },
        COMPOST: { id: "COMPOST", value: "Komposztáló", enabled: true },
        CLOTHES_DROPOFF: {
          id: "CLOTHES_DROPOFF",
          value: "Ruhagyűjtő konténer",
          enabled: true,
        },
        ELECTRIC_WASTE: {
          id: "ELECTRIC_WASTE",
          value: "Elektronikai hulladék",
          enabled: true,
        },
        USED_BATTERY: {
          id: "USED_BATTERY",
          value: "Használt elem",
          enabled: true,
        },
        USED_OIL: { id: "USED_OIL", value: "Használt olaj", enabled: true },
        OTHER_SELECTIVE: {
          id: "OTHER_SELECTIVE",
          value: "Egyéb szelektív",
          enabled: true,
        },
      },
    },
    STATION: {
      id: "STATION",
      allEnabled: true,
      open: false,
      name: "Állomás",
      subcategories: {
        TOILET: { id: "TOILET", value: "Nyilvános WC", enabled: true },
        MOBILITY_POINT: {
          id: "MOBILITY_POINT",
          value: "Mobilitási pont",
          enabled: true,
        },
        WATER: { id: "WATER", value: "Ivóvíz", enabled: true },
        BIKE_SHARING: {
          id: "BIKE_SHARING",
          value: "Bringa megosztás",
          enabled: true,
        },
        SWAP_POINT: { id: "SWAP_POINT", value: "Csere-bere", enabled: true },
        // PLANT: { id: "PLANT", value: "Fa", enabled: true },
      },
    },
    COMMON_GOOD: {
      id: "COMMON_GOOD",
      allEnabled: true,
      open: false,
      name: "Közösség",
      subcategories: {
        SPORT_FACILITY: { id: "SPORT_FACILITY", value: "Sport", enabled: true },
        NATURE: { id: "NATURE", value: "Természet", enabled: true },
        COMMUNITY_GARDEN: {
          id: "COMMUNITY_GARDEN",
          value: "Közösségi kert",
          enabled: true,
        },
        PLAYGROUND: { id: "PLAYGROUND", value: "Játszótér", enabled: true },
        COMMUNITY_CENTER: {
          id: "COMMUNITY_CENTER",
          value: "Művelődési ház",
          enabled: true,
        },
        NGO: { id: "NGO", value: "Civil szervezet", enabled: true },
        EDUCATION_BUILDING: {
          id: "EDUCATION_BUILDING",
          value: "Oktatási intézmény",
          enabled: true,
        },
        COMMUNITY_PLACE: {
          id: "COMMUNITY_PLACE",
          value: "Közösségi hely",
          enabled: true,
        },
        OTHER_COMMUNITY: {
          id: "OTHER_COMMUNITY",
          value: "Egyéb közösségi hely",
          enabled: true,
        },
      },
    },
    SERVICES: {
      id: "SERVICES",
      allEnabled: true,
      open: false,
      name: "Szolgáltatás",
      subcategories: {
        ACCOMODATION: {
          id: "ACCOMODATION",
          value: "Szálláshely",
          enabled: true,
        },
        APPLICATION: {
          id: "APPLICATION",
          value: "Alkalmazás",
          enabled: true,
        },
        OTHER_SERVICES: {
          id: "OTHER_SERVICES",
          value: "Egyéb szolgáltatás",
          enabled: true,
        },
        CATERING: {
          id: "CATERING",
          value: "Katering",
          enabled: true,
        },
      },
    },
    SUCCESS_STORY: {
      id: "SUCCESS_STORY",
      allEnabled: true,
      open: false,
      name: "Sikersztori",
      subcategories: {
        BAD_STORY: { id: "BAD_STORY", value: "Szégyenfolt", enabled: true },
        GOOD_STORY: { id: "GOOD_STORY", value: "Sikertörténet", enabled: true },
        POWER_OF_COMMUNITY: {
          id: "POWER_OF_COMMUNITY",
          value: "A közösség ereje",
          enabled: true,
        },
      },
    },
  });

  activeFilter = $derived(
    !Object.values(this.filters).every((category) => {
      return Object.values(category.subcategories).every((subcategory) => {
        return subcategory.enabled;
      });
    })
  );

  everyFilterEnabled = $derived(
    Object.values(this.filters).every((c) => c.allEnabled)
  );

  toggleAllFiltersAndSubcategories() {
    this.couponFilter = false;
    this.categories.forEach((c) => (c.active = false));
    const newValue = !this.everyFilterEnabled;
    Object.values(this.filters).forEach((category) => {
      category.allEnabled = newValue;
      Object.values(category.subcategories).forEach((subcategory) => {
        subcategory.enabled = newValue;
      });
    });
    poiStore.applyFilters();
  }

  toggleMainFilter(id: CategoryId) {
    this.couponFilter = false;
    this.categories.forEach((c) => (c.active = false));
    this.filters[id].allEnabled = !this.filters[id].allEnabled;
    Object.values(this.filters[id].subcategories).forEach((subcategory) => {
      subcategory.enabled = this.filters[id].allEnabled;
    });
    poiStore.applyFilters();
  }

  toggleSubFilter(categoryId: CategoryId, subcategoryId: SubcategoryId) {
    this.couponFilter = false;
    this.categories.forEach((c) => (c.active = false));
    this.filters[categoryId].subcategories[subcategoryId].enabled =
      !this.filters[categoryId].subcategories[subcategoryId].enabled;

    const allEnabled = Object.values(
      this.filters[categoryId].subcategories
    ).every((sub) => sub.enabled);
    const noneEnabled = Object.values(
      this.filters[categoryId].subcategories
    ).every((sub) => !sub.enabled);

    if (allEnabled || noneEnabled) {
      this.filters[categoryId].allEnabled = allEnabled;
    } else {
      this.filters[categoryId].allEnabled = false;
    }

    const allCategoriesEnabled = Object.values(this.filters).every(
      (cat) => cat.allEnabled
    );
    this.everyFilterEnabled = allCategoriesEnabled;

    poiStore.applyFilters();
  }

  getActiveSubcategories(): string[] {
    const result: string[] = [];

    if (this.couponFilter) {
      return []; // coupons are handled separately
    }

    Object.values(this.filters).forEach((category) => {
      Object.values(category.subcategories).forEach((sub) => {
        if (sub.enabled) {
          result.push(sub.id);
        }
      });
    });

    return result;
  }
}

export const filtersStore = new FiltersStore();
